import axios from "axios";
export const generateMpcWalletUserShare = async (clientSessionToken) => {
    const response = await axios.post("https://mpc-client.portalhq.io/v1/generate", "{}", {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientSessionToken}`,
        },
    });
    return response.data;
};
export const getPortalClientInfo = async (clientSessionToken) => {
    const response = await axios.get("https://api.portalhq.io/api/v3/clients/me", {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientSessionToken}`,
        },
    });
    //console.log("getPortalClientInfo", response);
    return response.data;
};
export const backup = async (clientSessionToken, userShare) => {
    const response = await axios.post("https://mpc-client.portalhq.io/v1/backup", {
        generateResponse: JSON.stringify(userShare),
    }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientSessionToken}`,
        },
    });
    //console.log("PortalHQ:backup", response);
    //console.log("PortalHQ:backup data=", response.data);
    return response.data;
};
export const recover = async (clientSessionToken, backupShares) => {
    //console.log("https://mpc-client.portalhq.io/v1/recover clientSessionToken=", clientSessionToken);
    const response = await axios.post("https://mpc-client.portalhq.io/v1/recover", {
        backupResponse: JSON.stringify(backupShares),
    }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientSessionToken}`,
        },
    });
    //console.log("PortalHQ:recovery", response);
    //console.log("PortalHQ:recovery data=", response.data);
    return response.data;
};
